/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Lifeskill } from '../../models/lifeskill';

export interface GetLifeskillId$Json$Params {

/**
 * Lifeskill id
 */
  id: string;
  'api-version'?: string;
}

export function getLifeskillId$Json(http: HttpClient, rootUrl: string, params: GetLifeskillId$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Lifeskill>> {
  const rb = new RequestBuilder(rootUrl, getLifeskillId$Json.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('api-version', params['api-version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Lifeskill>;
    })
  );
}

getLifeskillId$Json.PATH = '/lifeskill/{id}';
